import React, { useEffect } from 'react';
import styles from './ManagerInsuranceCompaniesCaseTypes.module.scss';
import ManagerInsuranceCompaniesCaseTypesSubMenu from '../ManagerInsuranceCompaniesCaseTypesSubMenu/ManagerInsuranceCompaniesCaseTypesSubMenu';
import {
	PaginationOrderHow,
	useWorkplaceMedicalProceduresQuery,
} from '../../../../../../graphql/graphql';
import { useAppContext } from '../../../../../../Services/AppContext';
import Loading from '../../../../../../Components/Loading';
import { useFlatDataList } from '../../../../../Base/Hooks/useFlatDataList';
import { WorkplaceMedicalProcedure } from '../../../../Consts/CaseTypesDefaultColumns.const';
import { CustomSettingsContextProvider } from '../../../../../CustomSettings/Services/CustomSettingsContext';
import { CustomSettingKey } from '../../../../../Base/Enums/CustomSettingKey.enum';
import ManagerInsuranceCompaniesCaseTypesTable from '../ManagerInsuranceCompaniesCaseTypesTable/ManagerInsuranceCompaniesCaseTypesTable';

interface Props {
	defaultAction: () => void;
}

const ManagerInsuranceCompaniesCaseTypes = ({ defaultAction }: Props) => {
	const { workplaceId } = useAppContext();
	const { flatData, pagination, getNextPage, appendData } =
		useFlatDataList<WorkplaceMedicalProcedure>({ workplaceId });
	const { data, isLoading, refetch } = useWorkplaceMedicalProceduresQuery(
		{
			where: { workplaceId },
			pagination: {
				...pagination,
				order: { key: 'created_at, id', how: PaginationOrderHow.Desc },
			},
		},
		{ refetchOnMountOrArgChange: true },
	);

	useEffect(() => {
		appendData(data?.workplaceMedicalProcedures?.data ?? []);
	}, [data, appendData]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<CustomSettingsContextProvider
			customSettingsKey={CustomSettingKey.CASE_TYPES}>
			<div className={styles.wrapper}>
				<ManagerInsuranceCompaniesCaseTypesSubMenu
					defaultAction={defaultAction}
					reloadData={refetch}
				/>
				<div className={styles.tableWrapper}>
					<ManagerInsuranceCompaniesCaseTypesTable
						data={flatData}
						isLoading={isLoading}
						onLoadMore={getNextPage}
						onRefresh={refetch}
						hasMoreData={Boolean(
							data?.workplaceMedicalProcedures?.meta?.hasNextPage,
						)}
						totalCount={data?.workplaceMedicalProcedures?.meta?.count}
					/>
				</div>
			</div>
		</CustomSettingsContextProvider>
	);
};

export default ManagerInsuranceCompaniesCaseTypes;
